import React, { Fragment } from "react";
import "./App.scss";
import "./PublicLayout.scss";
import { useGlobalState } from "./Context";
import { basePathName } from "./Utilities/HelperData";
import { AdminHelper } from "./Utilities/AdminHelper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as IconRegular from "@fortawesome/free-regular-svg-icons";
import { Link } from "react-router-dom";

export const PublicLayout: React.FC = ({ children }) => {
  const {
    wordPressSiteUrl,
    aboutUrl,
    privacyUrl,
    termsUrl,
    faqUrl,
    writeForUSUrl,
    getListedUrl,
    advertiseWithUsUrl,
    accessibilityStatementUrl,
  } = useGlobalState();

  const ShowDoNotSell = () => {
    if (window.Osano && window.Osano.cm && window.Osano.cm.showDoNotSell) {
      window.Osano.cm.showDoNotSell();
    } else {
      console.warn("Osano CMP not loaded or showDoNotSell function not available.");
    }
  }

  const ShowCookiePreferences = () => {
    if (window.Osano && window.Osano.cm && window.Osano.cm.showDrawer) {
      window.Osano.cm.showDrawer('osano-cm-dom-info-dialog-open');
    } else {
      console.warn("Osano CMP not loaded or showDrawer function not available.");
    }
  }

  return (
    <Fragment>
      {AdminHelper.isviewingACampaign() && (
        <div className="main__header regular-font align-items-center py-2">
          This link shows a preview of the campaign. Use the "copy" button (
          <FontAwesomeIcon
            className="pt-0 dusky-blue-color copy pointer-default"
            icon={IconRegular.faClone}
            size="lg"
            onClick={() => {}}
          />
          ) in the Edit Campaign screen to get a link you can share with
          providers.
        </div>
      )}
      <header className="public-header border-bottom box-shadow">
        <div className="large-container">
          <nav className="navbar navbar-expand-sm navbar-light navbar-toggleable-sm">
            <div className="larger-container">
              <a className="navbar-brand" href={wordPressSiteUrl}>
                <img
                  src={`${basePathName}/therapist_logo_blue.svg`}
                  className="logo"
                  alt="logo"
                />
              </a>
              <div className="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse"></div>
            </div>
          </nav>
        </div>
      </header>

      <div className="container large-padding">
        <main role="main" className="pb-3 pt-3">
          <div>{children}</div>
        </main>
      </div>

      <footer>
        <div className="container footer-container">
          <div className="row">
            <div className="col-md-12 col-lg-3">
              <a
                className="footer-logo"
                title="Find verified professionals"
                href={wordPressSiteUrl}
              >
                <img
                  src={`${basePathName}/therapist_logo_blue.svg`}
                  alt="logo"
                />
              </a>
            </div>
            <div className="col-md-12 col-lg-9 text-lg-left text-xs-center footer-nav">
              <a
                className="footer-about"
                title="therapist.com About us"
                href={aboutUrl}
              >
                About us
              </a>
              <a
                className="footer-about"
                title="therapist.com FAQs"
                href={faqUrl}
              >
                FAQs
              </a>
              <a
                className="footer-about"
                title="therapist.com Advertise"
                href={advertiseWithUsUrl}
              >
                Advertise
              </a>
              <a
                className="footer-about"
                title="therapist.com Accessibility"
                href={accessibilityStatementUrl}
              >
                Accessibility
              </a>
              <a
                className="footer-about"
                title="therapist.com Our Partners"
                href={"https://my.therapist.com/our-partners"}
              >
                Our Partners
              </a>
            </div>
          </div>
        </div>
        <div className="container subfooter-container">
            <div className="col-md-12">
                    ©{new Date().getFullYear()} - therapist.com All Rights Reserved.
                    &nbsp;               
                    <a
                      title="therapist.com Terms of Use"
                      href={termsUrl}
                    >
                      Terms of Use
                    </a>
                    &nbsp;|&nbsp;              
                    <a
                      title="therapist.com Privacy Notice"
                      href={privacyUrl}
                    >
                      Privacy Notice
                    </a>
                    &nbsp;|&nbsp;
                    <Link to="#"
                      onClick={ShowDoNotSell}
                    >
                      Your Privacy Choices
                    </Link>
                    &nbsp;|&nbsp;
                    <a
                      title="therapist.com Cookie Notice"
                      href={"https://therapist.com/privacy-notice/cookie-notice/"}
                    >
                      Cookie Notice
                    </a>
                    &nbsp;|&nbsp; 
                    <Link to="#"
                      onClick={ShowCookiePreferences}
                    >
                      Cookie Preferences
                    </Link>
            </div>
          </div>
      </footer>
    </Fragment>
  );
};

export default PublicLayout;
